import { useState } from "react";

export default function SignupGateModal({ onClose, onLogin }) {
  const [email,   setEmail]   = useState("");
  const [sent,    setSent]    = useState(false);
  const [loading, setLoading] = useState(false);
  const [err,     setErr]     = useState("");

  const send = async () => {
    if (!email.includes("@")) { setErr("Enter a valid email"); return; }
    setLoading(true); setErr("");
    try {
      const r = await fetch("/api/auth", { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({ email }) });
      if (r.ok) setSent(true); else setErr("Couldn't send link — try again");
    } catch { setErr("Network error — try again"); }
    setLoading(false);
  };

  return (
    <div style={{ position:"fixed", inset:0, zIndex:999, display:"flex", alignItems:"center", justifyContent:"center", padding:20, background:"rgba(0,0,0,0.88)", backdropFilter:"blur(8px)" }}>
      <div style={{ background:"#0A0A0A", border:"1px solid rgba(201,168,76,0.25)", borderRadius:24, padding:"40px 32px", maxWidth:440, width:"100%", position:"relative", boxShadow:"0 0 80px rgba(201,168,76,0.08)" }}>
        <div style={{ height:3, background:"linear-gradient(90deg,#5a3d0e,#e8c875,#ffe87a,#e8c875,#5a3d0e)", backgroundSize:"200% auto", animation:"hmaShimmer 4s linear infinite", borderRadius:"16px 16px 0 0", position:"absolute", top:0, left:0, right:0 }}/>
        <button onClick={onClose} style={{ position:"absolute", top:16, right:16, background:"none", border:"none", color:"rgba(255,255,255,0.3)", fontSize:20, cursor:"pointer", lineHeight:1, padding:4 }}>✕</button>

        {sent ? (
          <div style={{ textAlign:"center", padding:"8px 0" }}>
            <div style={{ fontSize:36, marginBottom:16 }}>📬</div>
            <div style={{ fontSize:20, fontWeight:800, color:"#fff", marginBottom:8 }}>Check your inbox</div>
            <div style={{ fontSize:14, color:"rgba(255,255,255,0.5)", lineHeight:1.6 }}>We sent a magic link to <strong style={{ color:"#e8c875" }}>{email}</strong>. Click it to get full access — no password needed.</div>
          </div>
        ) : (
          <>
            <div style={{ textAlign:"center", marginBottom:28 }}>
              <div style={{ fontSize:11, fontWeight:900, letterSpacing:".2em", textTransform:"uppercase", color:"#e8c875", marginBottom:10 }}>◆ FREE ACCOUNT</div>
              <div style={{ fontSize:24, fontWeight:900, color:"#fff", lineHeight:1.2, marginBottom:10 }}>You've used your free analysis</div>
              <div style={{ fontSize:14, color:"rgba(255,255,255,0.5)", lineHeight:1.6 }}>Sign up free to run more analyses, save stocks to your watchlist, and get weekly picks delivered to your inbox.</div>
            </div>

            <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:16 }}>
              {["Unlimited analyses","Watchlist & price alerts","Weekly AI-curated picks","Performance track record"].map(f => (
                <div key={f} style={{ display:"flex", alignItems:"center", gap:10, fontSize:13, color:"rgba(255,255,255,0.7)" }}>
                  <span style={{ color:"#00C805", fontSize:16, fontWeight:900, lineHeight:1 }}>✓</span> {f}
                </div>
              ))}
            </div>

            <div style={{ display:"flex", gap:8, marginBottom:err?8:0 }}>
              <input
                type="email"
                value={email}
                onChange={e=>setEmail(e.target.value)}
                onKeyDown={e=>e.key==="Enter"&&send()}
                placeholder="your@email.com"
                style={{ flex:1, background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:10, padding:"12px 14px", color:"#fff", fontSize:14, outline:"none" }}
                autoFocus
              />
              <button onClick={send} disabled={loading} style={{ background:"linear-gradient(135deg,#e8c875,#ffe87a)", color:"#000", fontWeight:800, fontSize:14, padding:"12px 20px", borderRadius:10, border:"none", cursor:"pointer", whiteSpace:"nowrap" }}>
                {loading ? "…" : "Get Access →"}
              </button>
            </div>
            {err && <div style={{ fontSize:12, color:"#FF3B30", marginTop:4 }}>{err}</div>}
            <div style={{ fontSize:11, color:"rgba(255,255,255,0.25)", textAlign:"center", marginTop:12 }}>No credit card required · Cancel anytime</div>
          </>
        )}
      </div>
    </div>
  );
}
